export const DEFAULT_SEARCH_SCREEN_DIALOG_STYLE = {
    width: 'calc(71%)',
    maxWidth: 'calc(71%)',
    height: 'calc(100% - 300px)',
    maxHeight: 'calc(100% - 300px)',
};
